class FurnitureBuilder {
    /**
     * Transform furniture data in to Konva object json.
     * @param {Furniture[]} furnitureJson furniture from room.json
     * @returns {object[]} an array of furniture as Konva objects
     */
    buildRoomChildren(furnitureJson) {
        const furnitureResult = [];
        for (const [key, furniture] of Object.entries(furnitureJson)) {
            if (!furniture.attrs) {
                furniture.attrs = {};
            }
            if (furniture.initiallyVisible !== undefined && furniture.initiallyVisible !== null) {
                furniture.attrs.visible = furniture.initiallyVisible;
                delete furniture.initiallyVisible;
            }
            const shape = {
                ...furniture,
                attrs: {
                    ...furniture.attrs,
                    id: key,
                    category: "furniture"
                }
            };
            furnitureResult.push(shape);
        }
        return furnitureResult;
    }
}

export { FurnitureBuilder };
//# sourceMappingURL=FurnitureBuilder.js.map
